/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState, useContext } from "react";
import bg_image from "../../assets/home-bg.png";
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";
import API from "../../utils/API";
import Swal from "sweetalert2";
import { AppContext } from "../../utils/ContextProvider";
import Loader from "../../components/loader";

function Login() {
  const [buttonText, setButtonText] = useState("Entrar");
  const context = useContext(AppContext);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const userName = useRef();
  const password = useRef();
  const navigate = useNavigate();

  const logIn = (e) => {
    e.preventDefault();
    setError("");

    if (!userName.current.value) {
      setError("MISSING");
      return;
    }
    if (!password.current.value) {
      setError("MISSING");
      return;
    }

    setLoading(true);
    const cancelToken = API.cancelToken();

    API.logIn(cancelToken, userName.current.value, password.current.value)
      .then((res) => {
        setLoading(false);
        context.logIn(res.data, res.data.token);
        window.location.href = "/dashboard";
      })
      .catch((err) => {
        console.log(err);
        if (err.message === "cancelling") return;
        setLoading(false);
        if (err.response && (err.response.status === 401 || err.response.status === 404)) {
          setError("INVALID");
        } else {
          Swal.fire({
            title: "Error.",
            text: "Please try again later.",
            icon: "warning",
            confirmButtonText: "Ok",
          });
        }
      });

    return () => {
      API.cancel(cancelToken);
    };
  };

  return (
    <div className="bg-white">
      <div className="flex gap-5 max-md:flex-col max-md:gap-0">
        <div className="flex flex-col w-[62%] max-md:ml-0 max-md:w-full">
          <div className="flex overflow-hidden relative flex-col grow justify-center min-h-screen max-md:max-w-full">
            <img src={bg_image} className="object-cover absolute inset-0 size-full" />
            <div className="relative shrink-0 bg-black bg-opacity-70 h-screen max-md:max-w-full" />
          </div>
        </div>

        <div className="flex flex-col ml-5 w-[38%] max-md:ml-0 max-md:w-full">
          <div className="flex grow justify-center items-center self-stretch px-16 py-12 max-md:px-5 max-md:max-w-full">
            <div className="flex flex-col max-w-full w-[300px] max-md:mt-10">
              <img src={logo} className="w-full max-md:w-24" />

              {/* ✅ Wrap inputs + button in a form and submit on Enter */}
              <form onSubmit={logIn} className="mt-12 max-md:mt-10">
                <label className="block text-sm font-medium leading-5 text-zinc-700">
                  E-mail
                </label>
                <input
                  ref={userName}
                  type="email"
                  autoComplete="username"
                  className="w-full shrink-0 p-3 mt-1.5 h-11 rounded-sm border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)]"
                />

                <label className="block mt-4 text-sm font-medium leading-5 text-zinc-700">
                  Senha
                </label>
                <div className="relative">
                  <input
                    ref={password}
                    type={showPass ? "text" : "password"}
                    autoComplete="current-password"
                    className="w-full flex flex-col justify-center items-end p-3 mt-1.5 h-11 rounded-sm border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] max-md:pl-5 pr-10"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPass((s) => !s)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-zinc-500"
                    aria-label={showPass ? "Ocultar senha" : "Mostrar senha"}
                  >
                    {showPass ? "Ocultar" : "Mostrar"}
                  </button>
                </div>

                {loading ? (
                  <div className="flex justify-center items-center mt-5">
                    <Loader light={true} />
                  </div>
                ) : (
                  <button
                    type="submit" // ✅ Pressing Enter triggers this
                    className="w-full justify-center items-center px-16 py-2 mt-5 text-base leading-6 text-center text-white whitespace-nowrap bg-lime-700 rounded-sm border border-solid shadow-sm border-[color:var(--Polar-Green-7,#389E0D)] max-md:px-5 cursor-pointer"
                  >
                    {buttonText}
                  </button>
                )}
              </form>

              <p className="text-[red] font-semibold mt-2">
                {error && "Usuário e/ou Senha Incorretos"}
              </p>
              {/* 
              <div className="mt-10 text-sm font-medium leading-5 text-zinc-700">
                AINDA NÃO TEM CONTA?
              </div>
              <Link to="../create/account" className="mt-1 text-xs leading-4 text-blue-700 underline cursor-pointer">
                Clique aqui
              </Link> 
              */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Login;
